const versionInfo = {
  version: '1.6.10',
  versionInfo: 'custom shipping fee',
};

export default versionInfo;
